import React from 'react'
import { Link } from 'react-router-dom'

const Home = () => {
  return (
    <div className='bg-white d-flex justify-content-center align-items-center flex-column'>
      <div className='home'>
        <h1 className='fs-2 d-flex justify-content-center align-items-center body_tag'>Free Invoice, Payslip & Quotation Generator – Create and Print PDF</h1>
        <p className=' d-flex justify-content-center align-items-center  body_tag_new'>Design and Customize Professional Documents in Minutes – Quick and Easy</p>
        <div className='d-flex gap-1 justify-content-center align-items-center flex-wrap flex-column'>

          {/* <Link to={'https://www.nexonweb.com/index'}><img src='/nexon_page-0001-removebg-preview - Copy.png' height="180px" width="200px" alt='nexonweb logo' className='home_logo'/></Link>
       */}
          <div className='d-flex justify-content-center align-items-center gap-2 flex-wrap mt-4'>
            <Link to={"/invoice-generator"} className='link'>
              <div className='body_card'>
                <h3 className='text-danger'>Invoice Generator</h3>
                <strong className='text-dark'>Create your free invoice today</strong>
              </div>
            </Link>
            <Link to={"/quotation-generator"} className='link'>
              <div className='body_card'>
                <h3 className='text-success '>Quotation Generator</h3>
                <strong className='text-dark'>Create professional Quotation/Estimate Free</strong>
              </div>
            </Link>
          </div>
          <Link to={'/payslip-generator'} className='link'>
            <div className='body_card'>
              <h3 className='text-warning'>Payslip Maker</h3>
              <strong className='text-dark'>Create Payslips for your employees</strong>
            </div>
          </Link>
        </div>
      </div>
      <div className='mt-3 home_footer'>
        <div className='d-flex flex-column'>
          <div className='d-flex gap-2'>
            <img src='/tick.png' height={"30px"} width={"30px"} alt='tick image' />
            <h4 className='w-100 text-success fw-bold '>Store and Manage Company & Employee Details Securely</h4>
          </div>
          <p className='w-100 d-flex justify-content-center'>Easily store your company and employee data once, then retrieve it effortlessly from the list without re-entering the information every time.</p>
        </div>
        <div className='d-flex flex-column'>
          <div className='d-flex gap-2'>
            <img src='/tick.png' height={"30px"} width={"30px"} alt='tick image' />
            <h4 className='w-100 text-success fw-bold '>Effortlessly Generate and Manage Payslips</h4>
          </div>
          <p className='w-100 d-flex justify-content-center'>Create professional payslips in just a few clicks and manage them seamlessly with our intuitive platform.</p>
        </div>
        <div className='d-flex flex-column'>
          <div className='d-flex gap-2'>
            <img src='/tick.png' height={"30px"} width={"30px"} alt='tick image' />
            <h4 className='w-100 text-success fw-bold '>Choose from Multiple Payslip Templates to Match Your Brand</h4>
          </div>
          <p className='w-100 d-flex justify-content-center'>Customize payslips to align with your company’s branding and requirements. Select from various templates to deliver clear, stylish, and professional payslips to your employees.</p>
        </div>
        <div className='d-flex flex-column'>
          <div className='d-flex gap-2'>
            <img src='/tick.png' height={"30px"} width={"30px"} alt='tick image' />
            <h4 className='w-100 text-success fw-bold '>Personalize Payslips with Custom Information</h4>
          </div>
          <p className='w-100 d-flex justify-content-center'>
            Add year-to-date (YTD) earnings, tax brackets, deductions, or any other custom data to personalize your payslips according to your business needs.</p>
        </div>
      </div>
    </div>
  )
}

export default Home
